// @ts-nocheck TODO: fix types for the entire file

import styled, { StyledComponent } from '@emotion/styled';
import { MenuItem as MuiMenuItem, MenuItemProps } from '@mui/material';
import pxToEm from 'theme/pxToEm';

export const MenuItem: StyledComponent<MenuItemProps> = styled(MuiMenuItem)`
  /* Hack to reduce !important usage */
  &.MuiMenuItem-root.MuiMenuItem-root {
    display: flex;
    padding: ${pxToEm(4)} ${pxToEm(8)};
    border-radius: ${pxToEm(4)};
    &:hover {
      background: ${({ theme }) => theme.palette.grey[200]};
    }
  }
`;

export const MenuIconContainer = styled.div`
  display: flex;
  min-width: ${pxToEm(26)};
  svg {
    width: 1.25em !important;
  }
`;
